import { render, staticRenderFns } from "./Fee2.vue?vue&type=template&id=09024a9a&scoped=true&"
import script from "./Fee2.vue?vue&type=script&lang=js&"
export * from "./Fee2.vue?vue&type=script&lang=js&"
import style0 from "./Fee2.vue?vue&type=style&index=0&id=09024a9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09024a9a",
  null
  
)

export default component.exports